import React, { useState } from 'react';
import { Box, Grid, makeStyles, Theme, useTheme } from '@material-ui/core';
import { WarningRounded } from '@material-ui/icons';
import { StyledText } from '../StyledText';
import { Publishing } from './publishingLogic';
import { ConnectorProfile } from '../../types/types';
import Button from '../Button';

interface StyleProps {
  publishable: boolean
}
const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) => ({
  root: {
    margin: theme.spacing(0),
    borderRadius: '8px',
    padding: 25,
    border: ((props) => `1px solid ${props.publishable ? theme.palette.secondary.main : '#FBBC05'}`),
    backgroundColor: '#FFF'
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  text: {
    marginLeft: '19px',
    marginRight: '20px',
    whiteSpace: 'normal'
  },
  button: {
    whiteSpace: 'nowrap'
  }
}));

interface ConnectorGuideProps {
  profile: ConnectorProfile
  handleClick?: () => Promise<void>
}

const ConnectorGuide: React.FC<ConnectorGuideProps> = ({
  profile,
  handleClick
}) => {
  const { getPublishingGuideConfigForConnector } = Publishing;
  const { message, publishable } = getPublishingGuideConfigForConnector(profile);
  const styles = useStyles({ publishable });
  const theme = useTheme();


  const warningColor = publishable ? theme.palette.secondary.main : '#FBBC05';

  return (
    <Grid id='publishing-guide' container wrap='nowrap' direction='column' justify='center' className={styles.root}>
      <Box className={styles.content}>
        <WarningRounded htmlColor={warningColor} />
        <StyledText variant='body1' className={styles.text} style={{ whiteSpace: 'normal' }}>
          {message}
        </StyledText>
        {
          handleClick
          && (
          <Button
            onClick={handleClick}
            className={styles.button}
          >
            Edit Profile
          </Button>
          )
        }
      </Box>
    </Grid>
  );
};

export default ConnectorGuide;
